import { render, staticRenderFns } from "./PortoContainer.vue?vue&type=template&id=0dad0d81&"
import script from "./PortoContainer.vue?vue&type=script&lang=js&"
export * from "./PortoContainer.vue?vue&type=script&lang=js&"
import style0 from "./PortoContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports